module.exports = __webpack_public_path__ + "media/images/v3/icon3-e73934630dc8734832e9b87b84deca4d.png";